import React from 'react';

/**
 * Employer names on job surfaces.
 *
 * jobs.company is NOT NULL, so an employer the listing does not name is ''.
 * Since 2026-10-07 the database also turns placeholders into '' (the trigger
 * a_af_company_resolve: "Not Specified", "N/A", "Our client", the job's own
 * title, a street address, a scraped page title), and fills the name from
 * the employer's ATS account where the board's other listings agree. About
 * 2,400 listings on the board still name no employer, most of them staffing
 * agency postings through JobDiva. Every surface that prints a company name
 * goes through employerName() so none of them renders "'s application page"
 * or a lone " · Remote".
 */

export const EMPLOYER_UNNAMED = 'Employer not named';

/** The employer's name, or null when the listing does not name one. */
export function employerName(company: string | null | undefined): string | null {
  const c = (company ?? '').trim();
  return c ? c : null;
}

/** "Acme's" or "the employer's", for sentences about the application. */
export function employerPossessive(company: string | null | undefined): string {
  const c = employerName(company);
  return c ? `${c}'s` : "the employer's";
}

/** A neutral mark for the logo tile when there is no employer to abbreviate. */
export function UnnamedEmployerMark({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </svg>
  );
}
